import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de65ce95e1de35/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65ce95e1de35/node_modules/next/dist/client/link.js");
